import { Injectable } from '@angular/core';

@Injectable()
export class SessionStorageService {

  public clearData(key: string) {
    sessionStorage.removeItem(key);
  }

  public saveData(key: string, value: string) {
    if (value) {
      sessionStorage[key] = value;
    } else {
      sessionStorage[key] = '';
    }
  }

  public getData(key: string) {
    if (sessionStorage[key]) {
      return sessionStorage[key];
    } else {
      return null;
    }
  }

  public clearAllSessionStorage() {
    sessionStorage.clear();
  }

}
